import { render, staticRenderFns } from "./multi-input.vue?vue&type=template&id=66c820d2"
import script from "./multi-input.vue?vue&type=script&lang=js"
export * from "./multi-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports